import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "./SiteHeader";
import { COMPANY, ESPACE_CLIENT_URL, LEGAL_LINKS } from "@/data/site";
import { SERVICES } from "@/data/services";
import { openCookieSettings } from "@/lib/consent";
import { AppQr } from "./AppQr";

export const SiteFooter = () => (
  <footer className="relative bg-[#0F2840] pb-36 text-white md:pb-24" data-testid="site-footer">
    <div className="stripe-mariniere h-3 opacity-90" />
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-12 lg:px-8">
      <div className="md:col-span-4">
        <Logo light size={64} />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/70">
          Votre tranquillité, notre engagement au quotidien. Conciergerie de confiance à Brest et dans le Finistère.
        </p>
      </div>
      <div className="md:col-span-2">
        <p className="eyebrow !text-[#ff7a7a]">Navigation</p>
        <ul className="mt-4 space-y-2 text-sm text-white/80">
          {NAV.map((n) => <li key={n.to}><Link className="hover:text-white" to={n.to} data-testid={`footer-nav-${n.id}`}>{n.label}</Link></li>)}
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow !text-[#ff7a7a]">Services à Brest</p>
        <ul className="mt-4 space-y-2 text-sm text-white/80">
          {SERVICES.filter((p) => p.slug !== "militaires").map((p) => <li key={p.slug}><Link className="hover:text-white" to={p.path} data-testid={`footer-service-${p.slug}`}>{p.nom}</Link></li>)}
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow !text-[#ff7a7a]">Contact</p>
        <ul className="mt-4 space-y-3 text-sm text-white/80">
          <li className="flex gap-2"><Phone className="h-4 w-4 shrink-0" /><a href={COMPANY.telephoneHref} className="hover:text-white" data-testid="footer-phone-link">{COMPANY.telephone}</a></li>
          <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white" data-testid="footer-email-link">{COMPANY.email}</a></li>
          <li className="flex gap-2" data-testid="footer-adresse"><MapPin className="h-4 w-4 shrink-0" /> {COMPANY.adresse}</li>
          <li className="text-xs text-white/60" data-testid="footer-horaires">{COMPANY.horaires}</li>
        </ul>
        <div className="mt-5 flex items-center gap-3"><AppQr size={72} id="footer-qr" /><span className="text-xs text-white/70">Scannez pour accéder<br />à votre espace client</span></div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-white/60 lg:px-8">
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          {LEGAL_LINKS.map((l) => <Link key={l.to} to={l.to} className="hover:text-white" data-testid={`footer-${l.id}-link`}>{l.label}</Link>)}
          <button onClick={openCookieSettings} className="hover:text-white" data-testid="footer-manage-cookies-btn">Gérer mes cookies</button>
          <a href={ESPACE_CLIENT_URL} className="hover:text-white" data-testid="footer-espace-client-link">Espace client</a>
        </div>
        <p data-testid="footer-legal-line">© {new Date().getFullYear()} {COMPANY.nom} · {COMPANY.dirigeant} EI · SIREN {COMPANY.siren} · {COMPANY.rcs} · Domiciliation commerciale et postale : {COMPANY.siege} · TVA non applicable (franchise en base)</p>
      </div>
    </div>
  </footer>
);
